<template>
  <section class="page-recharge">
    <header class="recharge-header main-second-bg main-cl a-3-bd">
      <!-- 充值 -->
      {{ $t("assets.recharge.recharge") }}
    </header>
    <div class="recharge-details main-second-bg">
      <div class="details-left">
        <!-- 币种 -->
        <div class="coinType">
          <AssetCoinSelect deposit v-model="symbol" @change="onSymbolChanged" init></AssetCoinSelect>
        </div>

        <mainChain
          v-if="haveBranch"
          class="mainChainClass"
          :branchArr="branchArr"
          :activeBranch="activeBranch"
          :branchTip="branchTip"
          @setActiveBranch="setActiveBranch"
        />
        <template v-if="showAddress">
          <!-- 二维码\地址 -->
          <div class="addressShow">
            <!-- 二维码 -->
            <div class="addressQRCode">
              <img :src="addressQRCode" alt="" />
            </div>
            <div class="addressText">
              <div class="details-title">
                <!-- <span>{{ showSymbol }}</span> -->
                <!-- 充值地址 -->
                {{ $t("assets.recharge.rechargeAddress") }}
              </div>
              <!-- 地址 -->
              <div class="address">
                <div class="text gray-30-bg main-cl">{{ address || "-" }}</div>
                <input :value="address" ref="address" />
                <span
                  v-if="!!address"
                  class="copy"
                  @click="copy('address')"
                  @mouseenter="handMouseenter('address')"
                  @mouseleave="handMouseleave('address')"
                >
                  <span>
                    <svg-icon class="icon icon-14" icon-class="resetCopyIcon"></svg-icon>
                  </span>
                </span>
              </div>
            </div>
          </div>

          <!-- 标签 -->
          <div class="addressPage" v-if="isHavePage">
            <div class="addressPageLabel">
              <span class="text">{{ $t("assets.recharge.label") }}</span>
              <!-- <span class="iconPage">
                <svg-icon class="icon icon-12" icon-class="rechargeTips"></svg-icon>
                <div class="iconPage-market">
                  {{ $t("assets.recharge.pageText") }}
                </div>
              </span> -->
              <a-tooltip
                placement="bottom"
                :arrowPointAtCenter="true">
                <svg-icon class="icon icon-12" icon-class="rechargeTips"></svg-icon>
                <template slot="title">
                  <div class="iconPage-market">
                    {{ $t("assets.recharge.pageText") }}
                </div>
                </template>
              </a-tooltip>
            </div>
            <!-- 地址 -->
            <div class="addressPageDetail">
              <div class="text gray-30-bg main-cl">{{ addressPage || '-' }}</div>
              <input :value="addressPage" ref="addressPage" />
              <span
                v-if="addressPage"
                class="copy"
                @click="copy('addressPage')"
                @mouseenter="handMouseenter('addressPage')"
                @mouseleave="handMouseleave('addressPage')"
              >
                <svg-icon class="icon icon-14" icon-class="resetCopyIcon"></svg-icon>
              </span>
            </div>
          </div>
          <!-- 充值最小金额or充值到账确认块 -->
          <div class="recharge-confirm">
            <div class="confirm-item">
              <!-- 最小充值金额 -->
              <div class="title">{{ $t("assets.recharge.minimumDepositAmount") }}</div>
              <div class="content">{{ toNonExponential(symbolInfo.depositMin) }} {{ showSymbol }}</div>
            </div>
            <div class="confirm-item">
              <!-- 充值到账 -->
              <div class="title">{{ $t("assets.recharge.depositcredited") }}</div>
              <!-- 次网络确认 -->
              <div class="content">{{symbolInfo.confirmations}} {{ $t("assets.recharge.networkConfirmation") }}</div>
            </div>
          </div>
          <!-- 提示 -->
          <div class="details-warking red-cl">
            <span class="wicon">
              <svg-icon class="icon icon-16" icon-class="warningIcon"></svg-icon>
            </span>
            <span class="text">
              <!-- 请勿向上述地址充值任何非本币种资产，否则资产将不可找回 -->
              {{ $t("assets.recharge.rechargeError") }}
            </span>
          </div>
        </template>
        <div class="placeholder" v-else>
          <div class="holderImage">
            <svg-icon icon-class="stop"></svg-icon>
            <span class="text gray-cl">{{$t('assets.depositStop')}}</span>
          </div>
        </div>
      </div>
      <div class="details-right">
        <div class="numberList">
          <ul class="numberList-key">
            <!-- 总额 -->
            <li>{{ $t("assets.recharge.lumpSum") }}</li>
            <!-- 可用 -->
            <li>{{ $t("assets.recharge.Available") }}</li>
            <!-- 冻结 -->
            <li>{{ $t("assets.recharge.freeze") }}</li>
          </ul>
          <ul class="numberList-value">
            <li v-for="(item, index) in detailsList" :key="index">
              <span class="value main-cl">{{ item.value | fixDFn(that) }}</span>
              <span class="unit main-cl">{{ showSymbol }}</span>
            </li>
          </ul>
        </div>
        <div v-if="symbol_deposit_msg" class="depositMsg b-2-cl">
          <p class="main-cl title">{{ $t("application.applyRegion.focus") }}: </p>
          <template v-for="(item, key) in symbolDepositMsgArr">
            <p class="content" :key="key">{{ item }}</p>
          </template>
        </div>
      </div>
    </div>
    <!-- 最近充值记录 -->
    <header class="recharge-header main-second-bg main-cl a-3-bd">
      {{ $t("assets.recharge.RecentRechargeRecord") }}
    </header>
    <div class="recharge-table main-second-bg">
      <c-table
        :imgMap="imgMap"
        :colorMap="colorMap"
        :loading="tabelLoading"
        :columns="columns"
        :dataList="tabelList"
      />
      <c-pagination
        v-if="paginationObj.total > paginationObj.display"
        :total="paginationObj.total"
        :display="paginationObj.display"
        :currentPage="paginationObj.currentPage"
        @pagechange="pagechange"
      />
    </div>
    <!-- 提示框 -->
    <c-alert
      :showFlag="alertFlag"
      :imgMap="imgMap"
      :colorMap="colorMap"
      @close="alertClone"
      @confirm="alertClone"
      :title="$t('assets.recharge.RechargeReminder')"
    >
      <div class="alertBox">
        <!-- 充值提醒 -->
        <!-- <div class="alertTitle b-2-cl">
          {{ $t("assets.recharge.RechargeReminder") }}
        </div> -->
        <!-- 充值时必须要填写充值地址和标签，这是您账户的唯一标识，不填或填错将导致您的资产丢失。-->
        <div class="alertText">{{ $t("assets.recharge.rechargeWarning") }}</div>
      </div>
    </c-alert>
  </section>
</template>
<script>
import mainChainMixins from 'BlockChain-ui-privatization/PC/common-mixin/assets/mainChainMixins';
import {
  fixD, getCoinShowName, colorMap, imgMap,
} from '@/utils';
import AssetCoinSelect from '@/views/components/AssetCoinSelect.vue';
import mainChain from './mainChain.vue';

export default {
  name: 'page-recharge',
  mixins: [mainChainMixins],
  components: {
    mainChain,
    AssetCoinSelect,
  },
  data() {
    return {
      symbolInfo: {},
      addressShow: true,
      addressPageShow: true,
      tabelLoading: true,
      alertFlag: false,
      imgMap,
      colorMap,
      detailsList: [
        { key: 'sum', value: '--' },
        { key: 'normal', value: '--' },
        { key: 'lock', value: '--' },
      ],
      address: '', // 地址
      addressPage: '', // 标签（xrp/eos）时
      addressQRCode: '', // 二维码地址
      tabelList: [], // 充值记录
      symbol: this.$route.query.symbol,
      havePageArr: ['XRP', 'EOS'], // 含有标签的币种
      paginationObj: {
        total: 0, // 数据总条数
        display: 10, // 每页显示条数
        currentPage: 1, // 当前页码
      },
      addressTime: null,
      branchTip: '',
      showAddress: true,
      getBranchLoading: false,
      symbol_deposit_msg: '',
      branchSymbolDepositMsg: '',
      loading: false,
    };
  },
  watch: {
    exchangeData(v) {
      if (v) {
        this.initDetails();
      }
    },
    symbol: {
      immediate: true,
      handler() {
        this.pageInit();
      },
    },
    market: {
      immediate: true,
      handler() {
        this.pageInit();
      },
    },
    paginationObjCurrentPage() {
      this.getTableList();
    },
  },
  filters: {
    fixDFn(v, that) {
      return fixD(v, that.showPrecision);
    },
  },
  computed: {
    isHavePage() {
      let flag = false;
      // 判断market是否请求下来
      if (this.market && this.market.coinList) {
        if (!this.haveBranch) {
          // 判断market.coinList是否有当前币种
          if (this.market.coinList[this.symbol]) {
            const { tagType } = this.market.coinList[this.symbol];
            flag = tagType;
          }
        } else if (this.market.followCoinList[this.symbol][this.activeBranch]) {
          const { tagType } = this.market.followCoinList[this.symbol][this.activeBranch];
          flag = tagType;
        }
      }
      return flag;
    },
    showSymbol() {
      let str = this.symbol;
      if (this.market && this.market.coinList && this.market.coinList[this.symbol]) {
        str = getCoinShowName(this.symbol, this.market.coinList);
      }
      return str;
    },
    paginationObjCurrentPage() {
      return this.paginationObj.currentPage;
    },
    that() {
      return this;
    },
    // 当前币种精度
    showPrecision() {
      let v = 0;
      const { market } = this.$store.state.baseData;
      if (market && market.coinList && market.coinList[this.symbol]) {
        v = market.coinList[this.symbol].showPrecision;
      }
      return v;
    },
    // finance/account_balance 接口返回成功的数据
    exchangeData() {
      return this.$store.state.assets.exchangeData;
    },
    // market 接口
    market() {
      return this.$store.state.baseData.market;
    },
    // 表格title
    columns() {
      return [
        { title: this.$t('assets.recharge.RechargeTime'), width: '20%' }, // 充值时间
        { title: this.$t('assets.recharge.RechargeCoin'), width: '10%' }, // 币种
        { title: this.$t('assets.recharge.RechargeVolume'), width: '30%' }, // 充值数量
        { title: this.$t('assets.recharge.RechargeNumber'), width: '20%' }, // 确认次数
        { title: this.$t('assets.recharge.RechargeStatus'), width: '20%' }, // 状态
      ];
    },
    symbolDepositMsgArr() {
      let arr = [];
      // 如果链上有注意事项则展示链上的注意事项,否则,展示主币的注意事项
      const message = this.branchSymbolDepositMsg || this.symbol_deposit_msg;
      if (message) {
        const splitArr = message.split('\\n');
        arr = splitArr.filter(item => !!item);
      }
      return arr;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    setActiveBranch(v) {
      this.activeBranch = v;
      this.initAddress();
    },
    init() {
      // 如果没有 finance/account_balance 接口返回成功的数据
      if (!this.exchangeData) {
        this.$store.dispatch('assetsExchangeData');
      } else {
        this.initDetails();
      }
      // 获取table表数据
      this.getTableList();
    },

    /**
     * 币种发生变化
     */
    onSymbolChanged(symbol) {
      this.$router.push({ name: this.$route.name, query: { symbol } });
      this.pageInit();
    },

    pageInit() {
      if (this.symbol && this.market) {
        this.showAddress = true;
        this.initDetails();
        this.branchInit(this.market);
        this.initAddress();
      }
    },

    toNonExponential(num) {
      if (num) {
        const m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
        return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
      }
      return num;
    },
    handMouseenter(name) {
      if (name === 'address') {
        this.addressShow = false;
      } else {
        this.addressPageShow = false;
      }
    },
    handMouseleave(name) {
      if (name === 'address') {
        this.addressShow = true;
      } else {
        this.addressPageShow = true;
      }
    },
    alertClone() {
      this.alertFlag = false;
    },
    initDetails() {
      if (!this.symbol || !this.exchangeData) {
        return;
      }
      const obj = this.exchangeData.allCoinMap[this.symbol];
      const normalBalance = Number(obj.normal_balance) || Number(obj.overcharge_balance);
      this.detailsList = [
        { key: 'sum', value: obj.total_balance },
        { key: 'normal', value: normalBalance },
        { key: 'lock', value: obj.lock_balance },
      ];
    },
    getBranchAddress() {
      if (this.getBranchLoading) {
        return;
      }
      this.getBranchLoading = true;
      this.axios({
        url: 'cost/Getcost',
        params: {
          symbol: this.activeBranch,
        },
      }).then((data) => {
        this.getBranchLoading = false;
        if (data.code.toString() === '0') {
          this.showAddress = true;
          this.branchTip = data.data.mainChainNameTip;
          this.branchSymbolDepositMsg = data.data.symbol_deposit_msg;
        } else {
          this.showAddress = false;
          this.$bus.$emit('tip', {
            text: this.$t('assets.recharge.notSupport'),
            type: 'error',
          });
        }
      }).catch(() => {
        this.getBranchLoading = false;
      });
    },
    initAddress() {
      if (!this.symbol || this.loading) {
        return;
      }
      const { tagType } = this.market.coinList[this.symbol];
      if (tagType === 1 || tagType === 2) {
        // this.isHavePage = tagType;
        setTimeout(() => {
          this.alertFlag = Boolean(tagType);
        }, 100);
      }
      if (this.haveBranch) {
        this.getBranchAddress();
      }
      this.loading = true;
      // 请求该数据详情
      this.axios({
        url: 'finance/get_charge_address',
        params: {
          symbol: !this.haveBranch ? this.symbol : this.activeBranch,
        },
      }).then((data) => {
        this.loading = false;
        if (data.code.toString() === '0') {
          // let { allCoinMap } = this.exchangeData
          this.symbol_deposit_msg = data.data.symbol_deposit_msg || '';
          this.addressQRCode = data.data.addressQRCode;
          this.symbolInfo = data.data;
          if (this.isHavePage) {
            const arr = data.data.addressStr.split('_');
            const [address, addressPage] = arr;
            this.address = address;
            this.addressPage = addressPage;
          } else {
            this.address = data.data.addressStr;
          }
        } else {
          this.showAddress = false;
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      }).catch(() => {
        this.loading = false;
        this.showAddress = false;
      });
    },
    copy(item) {
      if (item === 'address') {
        this.copyAddress();
      } else if (item === 'addressPage') {
        this.copyAddressPage();
      }
    },
    copyAddress() {
      const input = this.$refs.address;
      input.select();
      document.execCommand('copy');
      // 地址复制成功
      this.$bus.$emit('tip', { text: this.$t('assets.recharge.copyAddress'), type: 'success' });
    },
    copyAddressPage() {
      const input = this.$refs.addressPage;
      input.select();
      input.setSelectionRange(0, input.value.length);
      document.execCommand('copy');
      // 地址标签成功
      this.$bus.$emit('tip', { text: this.$t('assets.recharge.copyLabel'), type: 'success' });
    },
    pagechange(v) {
      this.paginationObj.currentPage = v;
    },
    getTableList() {
      this.axios({
        url: 'record/deposit_list',
        params: {
          pageSize: this.paginationObj.display, // 每页条数
          page: this.paginationObj.currentPage, // 页码
          coinSymbol: this.symbol,
        },
      }).then((data) => {
        if (data.code.toString() === '0') {
          const list = [];
          data.data.financeList.forEach((item, index) => {
            const { coinList } = this.market;
            const coinName = getCoinShowName(item.symbol, coinList);
            list.push({
              id: index,
              data: [
                item.createdAt, // 时间
                coinName, // 币种
                fixD(item.amount, this.showPrecision), // 充值数量
                item.confirmDesc, // 确认次数
                item.status_text, // 状态
              ],
            });
          });
          this.tabelLoading = false;
          this.tabelList = list;
          this.paginationObj.total = data.data.count > 30 ? 30 : data.data.count;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/common.scss";

.page-recharge {
  font-family: "Medium";
  .alertTitle {
    margin-bottom: 15px;
  }
  .alertText {
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    // padding-bottom: 20px;
  }
  .recharge-header {
    height: 55px;
    line-height: 55px;
    padding-left: 20px;
    font-size: 14px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }
  .recharge-details {
    padding: 24px;
    gap: 24px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;

    .details-left {
      flex: 1;

      .coinType {
        display: flex;
        gap: 8px;
        flex-direction: column;
        margin-bottom: 24px;

        .label {
          font-size: 12px;
        }

        .symbol {
          border-radius: 4px;
          padding: 14px 16px;
          font-size: 14px;
        }
      }
    }
    .details-right {
      margin-top: 24px;
      width: 380px;
    }

    .numberList {
      display: flex;
      justify-content: space-between;
      font-size: 14px;

      ul {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 26px;
      }
      .numberList-key {
        text-align: left;
      }

      .numberList-value {
        text-align: right;

        li {
          display: flex;
          gap: 16px;
          justify-content: flex-end;
        }
      }
      .numberList-last {
        margin-left: 64px;
      }
    }
    .details-warking {
      font-size: 14px;
      display: flex;
      gap: 6px;
      align-items: center;

      .wicon {
        margin-right: 6px;
      }
      .text {
        max-width: 400px;
        line-height: 18px;
      }
    }
    .addressPage {
      margin-bottom: 24px;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 6px;

      .addressPageLabel {
        display: flex;
        align-items: center;
        gap: 6px;

        .text {
          font-size: 12px;
        }

        // .iconPage {
        //   position: relative;
        //   cursor: pointer;
        //   &:hover {
        //     .iconPage-market {
        //       display: block;
        //       width: 300px;
        //     }
        //   }
        //   .iconPage-market {
        //     display: none;
        //     position: absolute;
        //     top: 0px;
        //     width: 340px;
        //     left: 24px;
        //     padding: 20px;
        //     box-sizing: border-box;
        //     font-size: 12px;
        //     letter-spacing: 0;
        //     line-height: 20px;
        //   }
        // }
      }

      .addressPageDetail {
        position: relative;
        .text {
          font-size: 12px;
          white-space: normal;
          word-wrap: break-word;
          word-break: break-all;
          width: 100%;
          padding: 14px 16px;
          line-height: 12px;
          border-radius: 4px;
          box-sizing: border-box;
        }

        input {
          position: absolute;
          opacity: 0;
          left: -1000px;
          top: -1000px;
        }

        .page {
          font-size: 12px;
        }

        .copy {
          position: absolute;
          margin-left: 9px;
          cursor: pointer;
          bottom: 12px;
          right: 14px;
        }
      }
    }

    .mainChainClass {
      margin-bottom: 40px;
    }

    .placeholder {
      width: 100%;
      height: 258px;
      position: relative;
      .holderImage {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 96px;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .text {
          font-size: 14px;
        }
      }
    }

    .addressShow {
      display: flex;
      gap: 11px;
      align-items: flex-end;
      margin-bottom: 24px;

      .addressQRCode {
        width: 80px;
        height: 80px;
        border-radius: 4px;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .addressText {
        display: flex;
        flex-direction: column;
        flex: 1;

        .details-title {
          font-size: 14px;
          line-height: 12px;
          span {
            margin-right: 7px;
          }
        }

        .address {
          width: 100%;
          margin-top: 6px;
          overflow: hidden;
          position: relative;
          input {
            position: absolute;
            opacity: 0;
            left: -1000px;
            top: -1000px;
          }
          .text {
            font-size: 12px;
            white-space: normal;
            word-wrap: break-word;
            word-break: break-all;
            width: 100%;
            padding: 14px 16px;
            line-height: 12px;
            border-radius: 4px;
            box-sizing: border-box;
          }
          .copy {
            position: absolute;
            margin-left: 9px;
            cursor: pointer;
            bottom: 12px;
            right: 14px;
          }
        }
      }
    }
  }
  .recharge-confirm{
    background: rgba(135, 137, 153, 0.3);
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 12px;
    .confirm-item{
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .title{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: #878999;
      }
      .content{
        font-family: 'Alpex';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        /* identical to box height, or 100% */
        text-align: right;
        color: #FFFFFF;
      }
    }
  }
  .recharge-table {
    width: 100%;
    box-sizing: border-box;
    .table-head,
    .table-body-bar,
    .pagination {
      padding: 0 !important;
    }
  }
  .alertBox {
    padding: 24px;
    box-sizing: border-box;
  }
}

.depositMsg {
  margin-top: 30px;
  font-size: 12px;
  line-height: 18px;

  .title {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .content {
    line-height: 18px;
    margin-bottom: 16px;

    &::before {
      display: inline-block;
      content: "";
      width: 5px;
      height: 5px;
      background-color: #878999;
      border-radius: 50%;
      transform: translate(0px, -2px);
      margin-right: 4px;
    }
  }
}

.iconPage-market {
  width: 340px;
  padding: 20px;
  box-sizing: border-box;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 20px;
}
</style>
